

















import Vue from 'vue'
import gql from 'graphql-tag'
import XButton from '@/components/atoms/Button/XButton.vue'
import MenuContents from '@/components/molecules/FfGoods/Detail/MenuContents.vue'

type Data = {
  goodsSpecId: string
  fulfillmentProcessId: string
}
export default Vue.extend<Data, {}, {}, {}>({
  name: 'FfGoodsDetail',
  components: { XButton, MenuContents },
  data() {
    return {
      goodsSpecId: this.$route.params.id,
      fulfillmentProcessId: this.$route.params.fulfillmentProcessId,
    }
  },
  apollo: {
    goodsMenus: {
      query: gql`
        query GoodsMenus($goodsSpecId: ID!, $fulfillmentProcessId: ID!) {
          goodsMenus(
            goodsSpecId: $goodsSpecId
            fulfillmentProcessId: $fulfillmentProcessId
          ) {
            menuId
            menu {
              menuId
              menuName
              catchPhrase
              description
              dishes {
                dishId
                name
                materials {
                  materialId
                  name
                }
              }
              allergens {
                allergenId
                name
              }
              additives {
                additiveId
                name
              }
            }
          }
        }
      `,
      variables() {
        return {
          goodsSpecId: this.goodsSpecId,
          fulfillmentProcessId: this.fulfillmentProcessId,
        }
      },
    },
  },
})
